module.exports = "# Mission Assignment\n\nTitle: Keep Saving Water!\n\n## Notes\n&nbsp;\n\n# Mission Intro Video\n\nYouTube: REPLACEME\n\n## Notes\n\nIan and Sara introduce Mission 2 - Keep Saving Water! (REPLACEME).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/sections/70_missionAssignment/level2_keepSavingWater.md
// module id = 1732
// module chunks = 2